import { Header } from '@/components/layout/Header';
import { useLanguage } from '@/contexts/LanguageContext';
import { User } from 'lucide-react';

export default function ProfilePage() {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header title={t('profile')} />
      
      <main className="flex-1 overflow-y-auto pb-16 hide-scrollbar">
        <div className="p-4">
          <div className="flex items-center justify-center flex-col mb-6">
            <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-3">
              <User className="h-10 w-10 text-muted-foreground" />
            </div>
            <h2 className="font-bold text-lg">Guest User</h2>
          </div>
        </div>
      </main>
    </div>
  );
}